import { render } from "./tplan-page.vue?vue&type=template&id=32729f23"
import script from "./tplan-page.vue?vue&type=script&lang=js"
export * from "./tplan-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__